import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react'; 
import tanuragalogo from "../assets/images/tanuraga-logo.png";
import axios from 'axios';
import Swal from 'sweetalert2';
import Spinner from "react-activity/dist/Spinner";
import { useDispatch } from 'react-redux';
import { apiUrl } from '../config/Config';

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const requestedRedirect = location.state?.redirectTo || searchParams.get('redirect') || '/';
  const redirectTo = requestedRedirect.startsWith('/') && !requestedRedirect.startsWith('//') ? requestedRedirect : '/';
  const [showloding, setshowloding] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: '', 
    password: '', 
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async(e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      Swal.fire({
        title: '',
        text: 'Email and password are required',
        icon: 'error',
        width: '350px',
        confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
          popup: "small-icon-alert",
        },
      });
      return;
    }

    setshowloding(true);
    const data = {
      email: formData.email,
      password: formData.password,
    };
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      }
    };

    await axios.post(apiUrl + 'customerlogin', data, headers).then((res) => {
      if(res.data.status === 'success') {
        dispatch({ type: "customerdata", payload: res.data.data });
        navigate(redirectTo, { replace: true });
      } else {
        Swal.fire({
          title: '',
          text: res.data.message,
          icon: 'error',
          width: '350px',
          confirmButtonText: 'Ok',
          confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
            popup: "small-icon-alert",
          },
        });
      }
    }).catch((err) => {
      alert(err.message);
    });
    setshowloding(false);
  };

  return (

    <div className="register-page-container"> 
      <div className="register-page-card"> 
        
      

       
        <div className="register-page-header">

          <h2 className="register-page-logo">
            <img src={tanuragalogo} className='loginpagelogo' alt="Tanuraga Logo" />
            </h2> 
          <p className="register-page-tagline">Customer Login</p>
        </div>
    

   
        <form className="login-page-form" onSubmit={handleSubmit}>
          
    
          <div className="register-page-form-group">
           
            <label htmlFor="email" className="register-page-label">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              className="register-page-input" 
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

 
          <div className="register-page-form-group">
    
            <div className="login-page-password-header">
              <label htmlFor="password" className="register-page-label">Password</label>
              <Link to="/forgot-password" className="login-page-forgot-link"> 
                Forgot password?
              </Link>
            </div>
            
            <div className="register-page-password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                className="register-page-input"
                value={formData.password}
                onChange={handleChange}
                required
              />
          
              <button
                type="button"
                className="register-page-password-icon"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>


          <button type="submit" className="register-page-button">
            {
              showloding ?
              <Spinner color='#fff' size={15} className='spinnerCenter' /> :
              "Login"
            }
          </button>
        </form>

        <p className="register-page-separator">Or</p>
 
        {/* <p className="login-page-footer-text">
          Don't have any account? 
          <a href="/register-shop-owner" className="register-page-link">
             Register as Shop 
             <span className="login-page-link-owner">Owner</span>
          </a>
        </p> */}
        <p className="register-page-footer">
           Don't have any account? <Link to={'/register'} state={{ redirectTo }} className="register-page-link">Sign Up</Link> 
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
